import React, { useCallback, useEffect, useRef, useState } from 'react';

var MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
var ACCEPTED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];

export default function ImageUpload({
  file, imageUrl, errors,
  onFileSelect, onRemove,
  translations
}) {
  var t = translations;
  var fileInputRef = useRef(null);
  var dragActiveState = useState(false);
  var dragActive = dragActiveState[0];
  var setDragActive = dragActiveState[1];
  var objectUrlState = useState(null);
  var objectUrl = objectUrlState[0];
  var setObjectUrl = objectUrlState[1];

  useEffect(function() {
    if (file instanceof File) {
      var url = URL.createObjectURL(file);
      setObjectUrl(url);
      return function() {
        URL.revokeObjectURL(url);
        setObjectUrl(null);
      };
    } else {
      setObjectUrl(null);
    }
  }, [file]);

  var previewSrc = file instanceof File ? objectUrl : imageUrl;

  var processFile = useCallback(function(f) {
    if (!f) return;
    if (ACCEPTED_TYPES.indexOf(f.type) === -1) {
      alert('Please upload a JPG, PNG, or GIF image.');
      return;
    }
    if (f.size > MAX_FILE_SIZE) {
      alert('Image must be smaller than 2MB.');
      return;
    }
    onFileSelect(f);
  }, [onFileSelect]);

  var handleFileChange = useCallback(function(e) {
    processFile(e.target.files && e.target.files[0]);
    e.target.value = '';
  }, [processFile]);

  var handleDrop = useCallback(function(e) {
    e.preventDefault();
    setDragActive(false);
    processFile(e.dataTransfer.files && e.dataTransfer.files[0]);
  }, [processFile]);

  var handleDragOver = useCallback(function(e) {
    e.preventDefault();
    setDragActive(true);
  }, []);

  var handleDragLeave = useCallback(function() {
    setDragActive(false);
  }, []);

  var handleDropzoneClick = useCallback(function() {
    if (fileInputRef.current) fileInputRef.current.click();
  }, []);

  var hasError = errors && errors.length > 0;

  return (
    <div className="article-image-upload">
      {previewSrc ? (
        <div className="article-image-upload__preview">
          <img src={previewSrc} alt="Preview" />
          <button
            type="button"
            className="article-image-upload__remove"
            onClick={onRemove}
            title={t.remove_image}
          >
            <i className="zmdi zmdi-close" />
          </button>
        </div>
      ) : (
        <div
          className={'article-image-upload__dropzone' + (dragActive ? ' article-image-upload__dropzone--active' : '') + (hasError ? ' article-image-upload__dropzone--error' : '')}
          onClick={handleDropzoneClick}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          role="button"
          tabIndex={0}
          onKeyDown={function(e) { if (e.key === 'Enter' || e.key === ' ') handleDropzoneClick(); }}
        >
          <p className="mb-1">{t.cover_image_drop}</p>
          <p className="text-muted mb-0">{t.cover_image_hint}</p>
        </div>
      )}
      {hasError && (
        <div className="text-danger small mt-1">
          {errors.join(', ')}
        </div>
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept=".jpg,.jpeg,.png,.gif"
        className="d-none"
        onChange={handleFileChange}
      />
    </div>
  );
}
